import {
  DatahubEntity,
  SchemaValidationErrorAction,
  ISchemaValidationErrorSchema,
  DATA_VERSION,
} from 'src/interfaces/Datahub';
import { sendEvent } from 'src/utils/datahubUtils';

class SchemaValidationError {
  sendEvent(event: ISchemaValidationErrorSchema) {
    const data = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    sendEvent(DatahubEntity.SCHEMA_VALIDATION_ERROR, SchemaValidationErrorAction.CREATE, data);
  }
}
export default SchemaValidationError;
